export default {
    namespaced: true,
    state: {
        user:"",
        userid:''
    },
    mutations: {
    setUser(state, payload) {
        state.user = payload
    },
    setUserId(state, payload) {
        state.userid = payload
    },
    delUser(state) {
        state.user = ""
    },
    },


}